// Put in the url to your own UNLOCKED Whereby Embedded room here
export const WHEREBY_ROOM: string | null = null;

export const PROD_URL = "https://hackday-sdk-demo.netlify.app/";
